import React, { useState, useEffect } from 'react';
import FooterQuickLinks from './FooterQuickLinks';
import FooterContact from './FooterContact';

const Footer = () => {
  const [showFloatingButton, setShowFloatingButton] = useState(false);
  useEffect(() => {
    function checkScroll() {
      const el = document.getElementById('mahotsavam');
      if (el) setShowFloatingButton(el.getBoundingClientRect().top <= window.innerHeight);
    }
    window.addEventListener('scroll', checkScroll);
    checkScroll();
    return () => window.removeEventListener('scroll', checkScroll);
  }, [setShowFloatingButton]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Temple Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_krishna-gallery/artifacts/0mnn7ivs_1000003725.png"
                alt="Temple Logo"
                className="w-10 h-10 text-gold animate-om"
              />
              <div>
                <h3 className="text-lg font-bold text-gold">SREE KRISHNASWAMY DEVASWOM</h3>
                <p className="text-sm text-gray-300">KODUNGALLUR</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              A sacred temple established in 1849 AD by the Perumbilli Kamath family for the redemption of 
              a cursed lineage. Now serving the Gowda Saraswat Brahmin community and devotees with 
              unwavering dedication to Lord Krishna.
            </p>
            <div className="flex space-x-4">
              <div className="bg-saffron text-white px-4 py-2 rounded-full text-sm font-semibold">
                GSB Heritage
              </div>
              <div className="bg-gold text-white px-4 py-2 rounded-full text-sm font-semibold">
                Since 1849
              </div>
              <div className="bg-green-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                Kodungallur
              </div>
            </div>
          </div>

          <FooterQuickLinks scrollToSection={scrollToSection} />
          <FooterContact />
        </div>

        {/* Sevas and Donation CTA */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="bg-gradient-to-r from-saffron to-gold rounded-xl p-6 text-center">
            <img
              src="https://customer-assets.emergentagent.com/job_krishna-temple-1/artifacts/5i40xtqi_unnamed.png"
              alt="Sacred blessing image"
              className="mx-auto mb-4 max-w-full h-auto rounded-lg shadow-temple"
            />
            <h3 className="text-xl font-bold mb-2">
              &quot;May your act of pure devotion bring you the supreme Anugraha of Sree Rajagopala Krishnaswamy&quot;
            </h3>
            <p className="text-base mb-4">
              Support the preservation of our sacred heritage and traditions
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                onClick={() => scrollToSection('donations')}
                className="bg-white text-saffron px-6 py-2 rounded-full font-semibold hover:bg-gray-100 transition-colors"
                data-testid="footer-donate-btn"
              >
                Sevas and Donation
              </button>
              <a
                href="https://youtu.be/IUWfp6gZBZg?feature=shared"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-saffron px-6 py-2 rounded-full font-semibold hover:bg-gray-100 transition-colors"
                data-testid="temple-pond-video-footer"
              >
                Temple Pond Video
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-black py-4 border-t border-gray-800">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <div className="text-sm text-gray-400">
              <p className="text-xs text-gray-600 mb-2">Most of the original art (AI generated images and painting) on the Samaaradhana Prasadam photo and on the photo under section IV are taken from Pinterest.</p>
              <p className="text-xs text-gray-600 mb-2">The photo of Lord Krishna in Tulsi Devi in Diwali section is taken from pinterest</p>
              <p className="text-xs text-gray-600 mb-2">The photo in the &apos;Samooha Unjal Seva&apos; section is taken from Pinterest.</p>
              <p>© 2026 SREE KRISHNASWAMY DEVASWOM, Kodungallur. All rights reserved.</p>
              <p className="text-xs text-gray-600">Hare Krishna Hare Rama</p>
            </div>
            
            <div className="flex items-center space-x-4">
              <div className="text-sm text-gray-400">
                GSB Heritage &bull; Est. 1849
              </div>
              <button
                onClick={scrollToTop}
                className="bg-saffron text-white p-2 rounded-full hover:bg-opacity-80 transition-colors"
                data-testid="scroll-top-btn"
              >
                ↑
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Sevas and Donation Button */}
      {showFloatingButton && (
        <div className="fixed bottom-6 right-6 z-40">
          <button
            onClick={() => scrollToSection('donations')}
            className="bg-gradient-to-r from-saffron to-gold text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 animate-slow-pulse"
            data-testid="floating-donate-btn"
          >
            <span className="text-xl font-bold">Sevas and Donation</span>
          </button>
        </div>
      )}
    </footer>
  );
};

export default Footer;
